import { createRouter, createWebHistory } from 'vue-router';
import {
  getAssignedSucursales,
  getCurrentSucursalIdFromSession,
  getAuthPermissions,
  hasAnyPermission,
  hasAuthToken,
  setCurrentSucursalId
} from '@/services/authSessionService';
import operationalConfigService from '@/services/operationalConfigService';
import { puedeUsarCompraDesdeFoto } from '@/utils/compraDesdeFoto.mjs';
import { puedeUsarCargaInicial } from '@/utils/cargaInicial.mjs';
import ClientesView from '../views/ClientesView.vue'; // Importa la vista de Clientes
import PantallaInicio from '../views/PantallaInicio.vue'; 
import LoginView from '../views/LoginView.vue';
import FirstAccessView from '../views/FirstAccessView.vue';
import FacturaView from '../views/Factura.vue'; // Importa la pantalla de Factura
import NotaDeRemision from '../views/NotaDeRemision.vue'; // Importa la pantalla de NotaDeRemision
import ListarComprobantes from '../views/ListarComprobantes.vue'; // Importa la pantalla de ListarComprobantes
import GestionPedidos from '../views/GestionPedidos.vue';
import EPedidosView from '../views/EPedidosView.vue';
import UserManagement from '../views/UserManagement.vue'; // Importa UserManagement
import RegistrarProveedor from '@/components/RegistrarProveedorModal.vue';
import RegistrarProductoModal from '@/components/RegistrarProductoModal.vue';
import ProductosPrecioView from '@/views/Inventario/ProductosPrecioView.vue'; // Importa la pantalla de Productos
import ProveedoresView from '@/views/ProveedoresView.vue';
import PermisosView from '@/views/PermisosView.vue';
import ListarComprobantesNT from '@/views/ListarComprobantesNT.vue';
import RolesView from '@/views/RolesView.vue';
import CajaView from '@/views/CajaView.vue'; // Importa la pantalla de Caja
import CerrarCajaView from '@/views/CerrarCajaView.vue'
import CobroFacturaVentaView from '@/views/CobroFacturaVentaView.vue';
import CobroVentaRapidaView from '@/views/CobroVentaRapidaView.vue';
import IngresoVariosView from '@/views/IngresoVariosView.vue';
import EgresoVariosView from '@/views/EgresoVariosView.vue';
import MovimientosCajaView from '@/views/MovimientosCajaView.vue';
import CobroClienteCredito from '@/views/CobroClienteCredito.vue';
import PagoFactura from '@/views/PagoFactura.vue';
import InventoryLayout from '@/views/InventoryLayout.vue';
import MaintenanceLayout from '@/views/Mantenimiento/MaintenanceLayout.vue';
import DashboardView   from '@/views/Inventario/DashboardView.vue'
import ProductosView from '@/views/Inventario/ProductosView.vue';
import ImportacionProductosView from '@/views/Inventario/ImportacionProductosView.vue';
import PresentacionesView from '@/views/Inventario/PresentacionesView.vue';
import GruposPrecioView from '@/views/Inventario/GruposPrecioView.vue';
import MovimientosView from '@/views/Inventario/MovimientosView.vue';
import LotesView from '@/views/Inventario/LotesView.vue';
import ControlInventarioView from '@/views/Inventario/ControlInventarioView.vue';
import DepositosView from '@/views/Inventario/DepositosView.vue';
import MantenimientoOperativoView from '@/views/Inventario/MantenimientoOperativoView.vue';
import MantenimientoHomeView from '@/views/Mantenimiento/MantenimientoHomeView.vue';
import MantenimientoBalanzasView from '@/views/Mantenimiento/MantenimientoBalanzasView.vue';
import MantenimientoFiscalDashboardView from '@/views/Mantenimiento/MantenimientoFiscalDashboardView.vue';
import MantenimientoFiscalEstablecimientosView from '@/views/Mantenimiento/MantenimientoFiscalEstablecimientosView.vue';
import MantenimientoFiscalPuntosView from '@/views/Mantenimiento/MantenimientoFiscalPuntosView.vue';
import MantenimientoFiscalTimbradosView from '@/views/Mantenimiento/MantenimientoFiscalTimbradosView.vue';
import MantenimientoFiscalSeriesView from '@/views/Mantenimiento/MantenimientoFiscalSeriesView.vue';
import MantenimientoFiscalFacturacionView from '@/views/Mantenimiento/MantenimientoFiscalFacturacionView.vue';
import MantenimientoVentasPendientesFacturaView from '@/views/Mantenimiento/MantenimientoVentasPendientesFacturaView.vue';
import MantenimientoCajasView from '@/views/Mantenimiento/MantenimientoCajasView.vue';
import MantenimientoJobsView from '@/views/Mantenimiento/MantenimientoJobsView.vue';
// Sección Ecommerce propia (RF-2 de SPEC_SUITE_BASE_COMERCIO_v0.1.md).
// Las vistas de configuración e imágenes se movieron acá desde Mantenimiento.
import EcommerceLayout from '@/views/Ecommerce/EcommerceLayout.vue';
import EcommerceHomeView from '@/views/Ecommerce/EcommerceHomeView.vue';
import EcommerceConfiguracionView from '@/views/Ecommerce/EcommerceConfiguracionView.vue';
import EcommerceMensajesView from '@/views/Ecommerce/EcommerceMensajesView.vue';
import EcommerceImagenesView from '@/views/Ecommerce/EcommerceImagenesView.vue';
import ReportesLayout from '@/views/Reportes/ReportesLayout.vue';
import ReportesHomeView from '@/views/Reportes/ReportesHomeView.vue';
import ReportesVentasView from '@/views/Reportes/VentasView.vue';
import ReportesCierresCajaView from '@/views/Reportes/CierresCajaView.vue';
import ReportesProductosVendidosView from '@/views/Reportes/ProductosVendidosView.vue';
import ReportesCuentasPorCobrarView from '@/views/Reportes/CuentasPorCobrarView.vue';
import ReportesComprasProveedorView from '@/views/Reportes/ComprasProveedorView.vue';
import GerencialDashboardView from '@/views/DashboardView.vue';
import CategoriaView from '@/views/Inventario/CategoriaView.vue';
import UnidadMedidaView from '@/views/Inventario/UnidadMedidaView.vue';
import VentasFacturasView from '@/views/VentasFacturasView.vue';
import NotasCreditoView from '@/views/NotasCreditoView.vue';
import { checkForUpdate, isChunkLoadError } from '@/services/appVersionService';
// Vista de impresión (carga perezosa)
const FacturaPrint = () => import('@/views/FacturaPrint.vue');
const ClientesCreditoView = () => import('@/views/ClientesCredito/ClientesCreditoView.vue');
const ClienteCreditoAsignarView = () => import('@/views/ClientesCredito/ClienteCreditoAsignarView.vue');
const ClienteCreditoDetalleView = () => import('@/views/ClientesCredito/ClienteCreditoDetalleView.vue');
const ClienteCreditoCrearView = () => import('@/views/ClientesCredito/ClienteCreditoCrearView.vue');

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/first-access',
    name: 'FirstAccess',
    component: FirstAccessView
  },
  {
    path: '/registrar-proveedor',
    name: 'RegistrarProveedor',
    component: RegistrarProveedor,
    meta: { requiresAuth: true, permissions: ['crear_proveedor'] }
  },
  {
    path: '/permisos',
    name: 'Permisos',
    component: PermisosView,
    meta: { requiresAuth: true, permissions: ['ver_permisos'] }
  },
  {
    path: '/inventario',
    component: InventoryLayout,
    children: [
      {path: '',             name: 'InvDashboard',    component: DashboardView, meta: { requiresAuth: true, permissions: ['gestionar_alertas'] } },
      {path: 'productos',    name: 'InvProductos',    component: ProductosView, meta: { requiresAuth: true, permissions: ['ver_productos'] } },
      {path: 'importacion-productos', name: 'InvImportacionProductos', component: ImportacionProductosView, meta: { requiresAuth: true, permissions: ['crear_productos'] } },
      {path: 'presentaciones', name: 'InvPresentaciones', component: PresentacionesView, meta: { requiresAuth: true, permissions: ['ver_productos'] } },
      {path: 'grupos-precio', name: 'InvGruposPrecio', component: GruposPrecioView, meta: { requiresAuth: true, permissions: ['ver_precio_venta'] } },
      {path: 'movimientos',  name: 'InvMovimientos',  component: MovimientosView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      {path: 'lotes',        name: 'InvLotes',        component: LotesView },
      {path: 'control',      name: 'InvControl',      component: ControlInventarioView, meta: { requiresAuth: true, permissions: ['control_inventario_listar_control', 'control_inventario_cargar', 'control_inventario_generar'] } },
      {path: 'depositos',    name: 'InvDepositos',    component: DepositosView, meta: { requiresAuth: true, permissions: ['ver_depositos'] } },
      {path: 'mantenimiento', redirect: { name: 'MaintenanceOperational' } },
  {path: 'productos-precio', name: 'ProductosPrecio', component: ProductosPrecioView, meta: { requiresAuth: true, permissions: ['ver_precio_venta'] } },
  {path: 'categorias',   name: 'InvCategorias',   component: CategoriaView, meta: { requiresAuth: true, permissions: ['ver_categorias'] } }
  ,{path: 'unidades-medida', name: 'InvUnidadesMedida', component: UnidadMedidaView, meta: { requiresAuth: true, permissions: ['ver_unidad_medida'] } }
    ]
  },
  {
    path: '/mantenimiento',
    component: MaintenanceLayout,
    children: [
      { path: '', name: 'MaintenanceHome', component: MantenimientoHomeView },
      { path: 'operativo', name: 'MaintenanceOperational', component: MantenimientoOperativoView },
      { path: 'balanzas', name: 'MaintenanceScales', component: MantenimientoBalanzasView },
      { path: 'fiscal', name: 'MaintenanceFiscalDashboard', component: MantenimientoFiscalDashboardView },
      { path: 'fiscal/establishments', name: 'MaintenanceFiscalEstablishments', component: MantenimientoFiscalEstablecimientosView },
      { path: 'fiscal/points', name: 'MaintenanceFiscalPoints', component: MantenimientoFiscalPuntosView },
      { path: 'fiscal/timbrados', name: 'MaintenanceFiscalTimbrados', component: MantenimientoFiscalTimbradosView },
      { path: 'fiscal/series', name: 'MaintenanceFiscalSeries', component: MantenimientoFiscalSeriesView },
      { path: 'fiscal/facturacion', name: 'MaintenanceFiscalFacturacion', component: MantenimientoFiscalFacturacionView, meta: { requiresAuth: true, permissions: ['gestionar_facturacion_electronica'] } },
      // P2 (SPEC_VENTAS_INNOMINADAS_FACTURACION_DIFERIDA_v0.1.md RN-VI6, RN-VI7).
      { path: 'fiscal/ventas-pendientes-factura', name: 'MaintenanceVentasPendientesFactura', component: MantenimientoVentasPendientesFacturaView, meta: { requiresAuth: true, permissions: ['gestionar_ventas_pendientes_factura'] } },
      { path: 'cajas', name: 'MaintenanceCashboxes', component: MantenimientoCajasView, meta: { requiresAuth: true, permissions: ['actualizar_deposito'] } },
      { path: 'jobs', name: 'MaintenanceJobs', component: MantenimientoJobsView, meta: { requiresAuth: true, permissions: ['gestionar_jobs'] } },
      // Redirects de compatibilidad (RF-2): estas dos rutas se mudaron a la
      // sección /ecommerce. Se conservan como redirect para no romper
      // accesos guardados ni enlaces que ya circulan entre los operadores.
      { path: 'ecommerce', redirect: { name: 'EcommerceConfiguracion' } },
      { path: 'imagenes', redirect: { name: 'EcommerceImagenes' } }
    ]
  },
  {
    path: '/ecommerce',
    component: EcommerceLayout,
    // Cualquiera de los dos permisos habilita la sección; el layout y el
    // Resumen filtran después qué ítems se ven con cada uno. Sin el meta,
    // un usuario sin ninguno de los dos llegaba igual al Resumen y veía una
    // pantalla vacía en vez de ser redirigido (detectado verificando
    // permisos en navegador real).
    meta: { requiresAuth: true, permissions: ['gestionar_ecommerce', 'editar_productos'] },
    children: [
      { path: '', name: 'EcommerceHome', component: EcommerceHomeView },
      { path: 'configuracion', name: 'EcommerceConfiguracion', component: EcommerceConfiguracionView, meta: { requiresAuth: true, permissions: ['gestionar_ecommerce'] } },
      { path: 'mensajes', name: 'EcommerceMensajes', component: EcommerceMensajesView, meta: { requiresAuth: true, permissions: ['gestionar_ecommerce'] } },
      { path: 'imagenes', name: 'EcommerceImagenes', component: EcommerceImagenesView, meta: { requiresAuth: true, permissions: ['editar_productos'] } }
    ]
  },
  {
    path: '/reportes',
    component: ReportesLayout,
    meta: { requiresAuth: true, permissions: ['ver_reportes'] },
    children: [
      { path: '', name: 'ReportesHome', component: ReportesHomeView },
      { path: 'ventas', name: 'ReportesVentas', component: ReportesVentasView },
      { path: 'cierres-caja', name: 'ReportesCierresCaja', component: ReportesCierresCajaView },
      { path: 'productos-vendidos', name: 'ReportesProductosVendidos', component: ReportesProductosVendidosView },
      { path: 'cuentas-por-cobrar', name: 'ReportesCuentasPorCobrar', component: ReportesCuentasPorCobrarView },
      { path: 'compras-proveedor', name: 'ReportesComprasProveedor', component: ReportesComprasProveedorView }
    ]
  },
  {
    path: '/roles',
    name: 'Roles',
    component: RolesView,
    meta: { requiresAuth: true, permissions: ['ver_roles'] }
  },
  {
    path: '/cobro-cliente-credito',
    name: 'CobroClienteCredito',
    component: CobroClienteCredito,
    meta: { requiresAuth: true, permissions: ['cobrar_deuda'] }
  },
  {
    path: '/pago-factura',
    name: 'PagoFactura',
    component: PagoFactura,
    meta: { requiresAuth: true, permissions: ['ver_pagos_pendientes', 'pagar_compra'] }
  },
  {
    path: '/ingreso-varios',
    name: 'IngresoVarios',
    component: IngresoVariosView,
    meta: { requiresAuth: true, permissions: ['registrar_ingreso_vario'] }
  },
  {
    path: '/egreso-varios',
    name: 'EgresoVarios',
    component: EgresoVariosView,
    meta: { requiresAuth: true, permissions: ['registrar_egreso_vario'] }
  },
  {
    path: '/proveedores/editar/:id',
    name: 'EditarProveedor',
    component: RegistrarProveedor,
    props: true,
    meta: { requiresAuth: true, permissions: ['editar_proveedor'] }
  },
  // Redirect de compatibilidad: `/productos` apuntaba a la vista de precios,
  // pese a su nombre. Ahora lleva al módulo de productos, que es lo que
  // promete. Se conserva la ruta para no romper accesos guardados; el permiso
  // lo aplica la guarda del destino (`ver_productos`).
  {
    path: '/productos',
    name: 'Productos',
    redirect: { name: 'InvProductos' }
  },
  {
    path: '/registrar-producto',
    name: 'RegistrarProducto',
    component: RegistrarProductoModal,
    meta: { requiresAuth: true, permissions: ['crear_productos', 'editar_productos'] }
  },
  {
    path: '/pantalla-inicio',
    name: 'Inicio',
    component: PantallaInicio
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: GerencialDashboardView,
    meta: { requiresAuth: true, permissions: ['ver_reportes'] }
  },
  {
    path: '/cobro-factura-venta',
    name: 'CobroFacturaVenta',
    component: CobroFacturaVentaView,
    meta: { requiresAuth: true, permissions: ['ver_cobros_pendientes', 'cobrar_venta'] }
  },
  {
    path: '/cobro-venta-rapida',
    name: 'CobroVentaRapida',
    component: CobroVentaRapidaView,
    meta: { requiresAuth: true, permissions: ['cobrar_venta'] }
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: ClientesView,
    meta: { requiresAuth: true, permissions: ['ver_cliente'] }
  },
  {
    path: '/clientes/creditos',
    name: 'ClientesCredito',
    component: ClientesCreditoView,
    meta: { requiresAuth: true, permissions: ['ver_credito'] }
  },
  {
    path: '/clientes/creditos/nuevo',
    name: 'ClienteCreditoCrear',
    component: ClienteCreditoCrearView,
    meta: { requiresAuth: true, permissions: ['crear_cliente_credito'] }
  },
  {
    path: '/clientes/:id/creditos/nuevo',
    name: 'ClienteCreditoAsignar',
    component: ClienteCreditoAsignarView,
    props: true,
    meta: { requiresAuth: true, permissions: ['crear_cliente_credito'] }
  },
  {
    path: '/clientes/creditos/:id',
    name: 'ClienteCreditoDetalle',
    component: ClienteCreditoDetalleView,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_credito'] }
  },
  // La compra por su id (pos-graciela-api/docs/SPEC_COMPRAS_POR_ID_v0.1.md,
  // fase B). Las rutas por número de abajo quedan para enlaces viejos: un
  // número como «33» también es numérico, así que no se adivina cuál es cuál.
  // Bajo /compras/ y no /factura/: el proxy manda todo /factura/<x> al
  // seguimiento público de facturas (nginx.lan.conf), así que una URL
  // /factura/... abierta directo o recargada (F5) nunca llega al SPA.
  {
    path: '/compras/factura/:idCompra(\\d+)',
    name: 'FacturaPorId',
    component: FacturaView,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] }
  },
  {
    // Permitimos IDs alfanuméricos con guiones (ej: FAC-120-19999-4) para que el refresh (F5)
    // matchee correctamente. Antes estaba restringido a solo dígitos (\d+) y al recargar
    // /factura/FAC-120-19999-4 no encontraba coincidencia => pantalla en blanco.
    path: '/factura/:id([A-Za-z0-9-]+)',
    name: 'Factura',
    component: FacturaView,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] }
  },
  {
    path: '/factura', // Ruta para registrar una nueva factura de compra
    name: 'RegistrarFactura',
    component: () => import('@/views/Factura.vue'), // Ruta al componente Factura
    props: route => ({
      datosParaFactura: route.query.datosParaFactura ? JSON.parse(decodeURIComponent(route.query.datosParaFactura)) : null,
    }),
    meta: { requiresAuth: true, permissions: ['crear_factura_compra'] }
  },
  // Carga inicial de stock (pos-graciela-api/docs/SPEC_CARGA_INICIAL_STOCK_Y_PRECIOS_v0.1.md
  // RH-1/RH-3 y §6.8). Además del permiso, el switch operativo: se lee del API
  // antes de entrar, para que una URL directa con el switch apagado no abra.
  {
    path: '/compras/carga-inicial',
    name: 'CargaInicialStock',
    component: () => import('@/views/Compras/CargaInicialStockView.vue'),
    meta: { requiresAuth: true, permissions: ['crear_factura_compra'] },
    beforeEnter: async () => {
      const config = await operationalConfigService.loadConfig();
      return puedeUsarCargaInicial({ habilitada: config.carga_inicial_stock_habilitada, permisos: getAuthPermissions() })
        ? true
        : { path: '/pantalla-inicio' };
    }
  },
  // Compra desde foto de factura (experimento): flag de build + permiso.
  // agente_productos/docs/SPEC_COMPRA_DESDE_FACTURA_v0.1.md, fase 2.
  {
    path: '/compras/desde-foto',
    name: 'CompraDesdeFoto',
    component: () => import('@/views/Compras/CompraDesdeFotoView.vue'),
    meta: { requiresAuth: true, permissions: ['crear_factura_compra'] },
    beforeEnter: () => (
      puedeUsarCompraDesdeFoto({ flag: process.env.VUE_APP_COMPRA_DESDE_FOTO, permisos: getAuthPermissions() })
        ? true
        : { path: '/pantalla-inicio' }
    )
  },
  {
    path: '/compras/carga-inicial/id/:idCompra(\\d+)',
    name: 'EditarCargaInicialPorId',
    component: () => import('@/views/Compras/CargaInicialStockView.vue'),
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] },
    beforeEnter: async () => {
      const config = await operationalConfigService.loadConfig();
      return config.carga_inicial_stock_habilitada === true ? true : { path: '/pantalla-inicio' };
    }
  },
  {
    path: '/compras/carga-inicial/:nro',
    name: 'EditarCargaInicial',
    component: () => import('@/views/Compras/CargaInicialStockView.vue'),
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] },
    beforeEnter: async () => {
      const config = await operationalConfigService.loadConfig();
      // Sin permiso de edición igual se ve, en modo lectura (CA-21): la
      // pantalla lo decide con el motivo que devuelve el API.
      return config.carga_inicial_stock_habilitada === true ? true : { path: '/pantalla-inicio' };
    }
  },
  {
    path: '/print/factura/id/:idCompra(\\d+)',
    name: 'FacturaPrintPorId',
    component: FacturaPrint,
    props: true
  },
  {
    path: '/print/factura/:id',
    name: 'FacturaPrint',
    component: FacturaPrint,
    props: true
  },
  {
    path: '/nota-de-remision/:id',
    name: 'NotaDeRemision',
    component: NotaDeRemision,
    props: true,
    meta: { requiresAuth: true, permissions: ['ver_nota_remision'] }
  },
  {
    path: '/nota-de-remision', // Ruta para registrar una nueva nota de remisión
    name: 'RegistrarNotaDeRemision',
    component: NotaDeRemision,
    meta: { requiresAuth: true, permissions: ['crear_nota_remision'] }
  },
  {
    path: '/listar-comprobantes',
    name: 'ListarComprobantes',
    component: ListarComprobantes,
    meta: { requiresAuth: true, permissions: ['ver_factura_compra'] }
  },
  {
    path: '/gestion-pedidos',
    name: 'GestionPedidos',
    component: GestionPedidos,
    meta: { requiresAuth: true, permissions: ['ver_pedidos_pendientes'] }
  },
  {
    path: '/gestion-pedidos/e-pedidos',
    name: 'EPedidos',
    component: EPedidosView,
    meta: { requiresAuth: true, permissions: ['gestionar_ecommerce'] }
  },
  {
    path: '/ventas-facturas',
    name: 'VentasFacturas',
    component: VentasFacturasView,
    meta: { requiresAuth: true, permissions: ['ver_ventas'] }
  },
  // SPEC_ANULACION_FACTURAS_Y_NOTAS_CREDITO_v0.2.md RN-AN24: "Devoluciones" se
  // reemplaza por el historial de notas de crédito, SIN alias. El formulario de
  // devolución queda fuera hasta la fase 2.
  {
    path: '/notas-credito',
    name: 'NotasCredito',
    component: NotasCreditoView,
    meta: { requiresAuth: true, permissions: ['gestionar_anulaciones'] }
  },
  {
    path: '/listar-notas-remision',
    name: 'ListarNotasDeRemision',
    component: ListarComprobantesNT,
    meta: { requiresAuth: true, permissions: ['ver_nota_remision'] }
  },
  {
    path: '/caja',
    name: 'Caja',
    component: CajaView,
    meta: { requiresAuth: true, permissions: ['abrir_caja', 'ver_caja'] }
  },
  {
    path: '/movimientos-caja',
    name: 'MovimientosCaja',
    component: MovimientosCajaView,
    meta: { requiresAuth: true, permissions: ['ver_caja'] }
  },
  {
    path: '/cerrar-caja',
    name: 'CerrarCaja',
    component: CerrarCajaView,
    meta: { requiresAuth: true, permissions: ['cerrar_caja'] }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, permissions: ['ver_usuarios'] }
  },
  {
    path: '/listar-proveedores',
    name: 'ListarProveedores',
    component: ProveedoresView,
    meta: { requiresAuth: true, permissions: ['ver_proveedor'] }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const isPublicRoute = to.path === '/' || to.path === '/first-access';

  if (!isPublicRoute && !hasAuthToken()) {
    next({ path: '/' });
    return;
  }

  if (!isPublicRoute) {
    const assignedSucursales = getAssignedSucursales();
    if (!assignedSucursales.length) {
      next({ path: '/' });
      return;
    }
    const currentSucursalId = getCurrentSucursalIdFromSession();
    const currentAllowed = assignedSucursales.some((item) => Number(item?.sucursal_id) === Number(currentSucursalId));
    if (!currentAllowed) {
      const preferred = assignedSucursales.find((item) => item.predeterminada) || assignedSucursales[0];
      setCurrentSucursalId(preferred?.sucursal_id);
    }
  }

  if (to.meta?.permissions && !hasAnyPermission(to.meta.permissions)) {
    next({ path: '/pantalla-inicio' });
    return;
  }

  next();
});

// Un chunk que ya no existe suele significar que hubo un deploy: se consulta la
// versión y, si cambió, aparece el aviso. Nunca se recarga sola.
router.onError((error) => {
  if (isChunkLoadError(error)) checkForUpdate();
});

export default router;
